// PatientData Model
import { Model } from '@vuex-orm/core'

export default class LabBtrData extends Model {
	// This is the name used as module name of the Vuex Store.
	static entity = 'LabBtrDatas'

	// List of all fields (schema) of the post model. `this.attr` is used
	// for the generic field type. The argument is the default value.
	static fields() {
		return {
			id: this.attr(null),
			btr_id: this.attr(null),
			hn: this.attr(null),
			vn: this.attr(null),
			an: this.attr(null),
			ptName: this.attr(null),
			transfusion_start_date: this.attr(null),
			transfusion_start_time: this.attr(null),
			symptom_start_date: this.attr(null),
			symptom_start_time: this.attr(null),
			lab_receive_status: this.attr(null),
			lab_cross_matching_status: this.attr(null),
			btr_status: this.attr(null),
			datas: this.attr(null),
			list_orderby: this.number(0)
		}
	}
}
